import React, {useState} from 'react';

import { useGetVacationTimesQuery } from '../../redux/services/vacationTimeApi';
import { useGetProviderAvailabilitiesQuery } from '../../redux/services/providerAvailabilityApi';
import { getStartAndEndDate } from '../../components/calendar/calendarUtils';
import useUser from '../../hooks/useUser';

import AppDashboard from '../AppDashboard';
import AvailabilityCalendarScreen from '../../components/availabilities/AvailabilityCalendarScreen';

const AvailabilityZonePage = () => {
  const [date, setDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState('week');
  const {startDate, endDate} = getStartAndEndDate({date, calendarView});
  const user = useUser();
  const providerId = user?.provider?.id;
  const awayTimesQuery = useGetVacationTimesQuery(
    {provider_id: providerId, start_time: startDate}, 
    {skip: !providerId}
  );
  const availabilityQuery = useGetProviderAvailabilitiesQuery(
    {provider_id: providerId}, 
    {skip: !providerId}
  );
  const childProps = {
    loading: awayTimesQuery.isLoading || availabilityQuery.isLoading || !user,
    awayTimes: awayTimesQuery?.data?.data || awayTimesQuery?.data || [],
    availabilities: availabilityQuery?.data?.data || [],
    date,
    calendarView,
    onDateChange: (e, dt) => setDate(dt),
    onCalendarViewChange: (e, v) => setCalendarView(v),
    error: awayTimesQuery?.isError ? availabilityQuery.error : null,
  };
  return (
    <AppDashboard 
      isLoading={childProps.loading}
      title='Availability Zones'
    >
      <AvailabilityCalendarScreen {...childProps} />
    </AppDashboard>
  );
};

export default AvailabilityZonePage;